import React, { useEffect, useState } from "react";

import {
    Box,
    Tabs,
    Tab,
    Paper,
    Fade
} from "@mui/material";

import { useLocation } from "react-router-dom";

import CalibrationGrid from "../MicroTip/CalibrationLayout";
import PredictionComponent from "../MicroTip/Predictions";

export default function NavigationTabs() {

    const location = useLocation();

    // =========================
    // INITIAL TAB
    // =========================
    const [activeTab, setActiveTab] = useState(() => {

        const savedTab =
            sessionStorage.getItem(
                "microtip-active-tab"
            );

        return savedTab
            ? Number(savedTab)
            : 0;
    });

    // =========================
    // HANDLE HISTORY LAUNCH
    // =========================
    useEffect(() => {

        if (location?.state?.openPredictionTab) {

            setActiveTab(1);

            sessionStorage.setItem(
                "microtip-active-tab",
                "1"
            );

            // Clear navigation state
            window.history.replaceState(
                {},
                document.title
            );
        }

    }, [location]);

    // =========================
    // SAVE ACTIVE TAB
    // =========================
    useEffect(() => {

        sessionStorage.setItem(
            "microtip-active-tab",
            activeTab
        );

    }, [activeTab]);

    // =========================
    // TAB CHANGE
    // =========================
    const handleChange = (
        event,
        newValue
    ) => {

        setActiveTab(newValue);
    };

    return (

        <Paper
            elevation={1}
            sx={{
                width: "100%",
                margin: "10px",
                mt: 2,
                borderRadius: 2,
                overflow: "hidden"
            }}
        >

            {/* TABS */}
            <Box
                sx={{
                    borderBottom: 1,
                    borderColor: "divider"
                }}
            >

                <Tabs
                    value={activeTab}
                    onChange={handleChange}
                    textColor="inherit"
                    indicatorColor="none"
                    sx={{

                        "& .MuiTab-root": {

                            textTransform: "none",
                            fontWeight: 400,
                            fontSize: "1rem",
                            minWidth: 240,

                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,

                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0,

                            color: "white",
                            backgroundColor: "#774def",

                            transition: "none"
                        },

                        "& .MuiTab-root:hover": {

                            color: "white",
                            fontWeight: 400,
                            fontSize: "1.1rem",
                            backgroundColor: "#774def"
                        },

                        "& .Mui-selected": {

                            color: "white",
                            backgroundColor: "#774def",
                            boxShadow: "none"
                        },

                        "& .MuiTabs-indicator": {

                            display: "none"
                        }
                    }}
                >

                    <Tab label="Calibration" />

                    <Tab label="Prediction" />

                </Tabs>

            </Box>

            {/* TAB PANELS */}
            <Box
                sx={{
                    position: "relative",
                    minHeight: 500,
                    overflow: "hidden"
                }}
            >

                {/* CALIBRATION */}
                <Fade
                    in={activeTab === 0}
                    timeout={300}
                    unmountOnExit
                >

                    <Box
                        sx={{

                            position:
                                activeTab === 0
                                    ? "relative"
                                    : "absolute",

                            width: "100%",
                            height: "100%"
                        }}
                    >

                        <CalibrationGrid />

                    </Box>

                </Fade>

                {/* PREDICTION */}
                <Fade
                    in={activeTab === 1}
                    timeout={300}
                    unmountOnExit
                >

                    <Box
                        sx={{

                            position:
                                activeTab === 1
                                    ? "relative"
                                    : "absolute",

                            width: "100%",
                            height: "100%"
                        }}
                    >

                        <PredictionComponent />

                    </Box>

                </Fade>

            </Box>

        </Paper>
    );
}